// Mode jour / nuit selon le lever et le coucher du soleil à Dakar (UTC+0 toute l'année)
const LAT = 14.6928;
const LNG = -17.4467;
const RAD = Math.PI / 180;
const KEY = "woma_theme_override";
const listeners = new Set();

// Minutes UTC du lever et du coucher du soleil (formule NOAA)
const sunTimes = (d) => {
  const day0 = Date.UTC(d.getUTCFullYear(), 0, 0);
  const n = Math.floor((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - day0) / 864e5);
  const g = ((2 * Math.PI) / 365) * (n - 1);
  const eqt = 229.18 * (0.000075 + 0.001868 * Math.cos(g) - 0.032077 * Math.sin(g) - 0.014615 * Math.cos(2 * g) - 0.040849 * Math.sin(2 * g));
  const decl = 0.006918 - 0.399912 * Math.cos(g) + 0.070257 * Math.sin(g) - 0.006758 * Math.cos(2 * g)
    + 0.000907 * Math.sin(2 * g) - 0.002697 * Math.cos(3 * g) + 0.00148 * Math.sin(3 * g);
  const ha = Math.acos(Math.cos(90.833 * RAD) / (Math.cos(LAT * RAD) * Math.cos(decl)) - Math.tan(LAT * RAD) * Math.tan(decl)) / RAD;
  return { rise: 720 - 4 * (LNG + ha) - eqt, set: 720 - 4 * (LNG - ha) - eqt };
};

const atMinutes = (d, mins) => Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) + mins * 60000;

// Mode automatique actuel + instant de la prochaine bascule
export const autoState = (now = new Date()) => {
  const { rise, set } = sunTimes(now);
  const riseTs = atMinutes(now, rise);
  const setTs = atMinutes(now, set);
  const t = now.getTime();
  if (t >= riseTs && t < setTs) return { mode: "day", next: setTs };
  if (t < riseTs) return { mode: "night", next: riseTs };
  const tomorrow = new Date(t + 864e5);
  return { mode: "night", next: atMinutes(tomorrow, sunTimes(tomorrow).rise) };
};

const readOverride = () => {
  try {
    const o = JSON.parse(localStorage.getItem(KEY) || "null");
    if (o && Date.now() < o.until) return o.mode;
    localStorage.removeItem(KEY);
  } catch (e) {
    localStorage.removeItem(KEY);
  }
  return null;
};

export const currentTheme = () => readOverride() || autoState().mode;

export const applyTheme = () => {
  const mode = currentTheme();
  if (document.documentElement.dataset.theme !== mode) {
    document.documentElement.dataset.theme = mode;
    listeners.forEach((fn) => fn(mode));
  }
  return mode;
};

// Choix manuel gardé jusqu'à la prochaine bascule automatique (lever / coucher du soleil)
export const setManualTheme = (mode) => {
  localStorage.setItem(KEY, JSON.stringify({ mode, until: autoState().next }));
  return applyTheme();
};

export const onThemeChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const installDayNight = () => {
  applyTheme();
  setInterval(applyTheme, 60000);
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && applyTheme());
};
